import React from 'react'
import Intro from '../Intro'

const Home: React.FC = () => <Intro fixed={true} />

export default Home
